import _clamp from 'lodash/clamp';
import { DEFAULT_IMAGE_FORMAT, IMAGE_FIT_CROP, IMAGE_QUALITY } from '@bedrock-rdk/constants';
import { imageService } from '@bedrock/fido-sdk';
import { BIG_FRAME_W, FRAME_H, FRAME_W, ORIGIN_IMAGE_W } from './storyboard.constants';

/**
 * Clamps value into 0..1 range
 *
 * @param {number} value
 * @returns {number} value in 0.. ~60000 range
 */
export const safeStoryboardValue = value => _clamp(value, 0, ORIGIN_IMAGE_W - FRAME_W);

export const getStoryboardUrl = (imageId, shift, width) => {
  const params = {
    fit: IMAGE_FIT_CROP,
    quality: IMAGE_QUALITY,
    format: DEFAULT_IMAGE_FORMAT,
    crop: `${shift},1`,
  };

  const url = imageService.getUrl(imageId, width, FRAME_H, params);

  return url;
};

export const getStoryboardGroupedFrames = imageId => {
  const framesList = [];
  const steps = ORIGIN_IMAGE_W / BIG_FRAME_W;

  for (let i = 0; i < steps; i += 1) {
    const shift = i * BIG_FRAME_W || 1;
    const image = getStoryboardUrl(imageId, shift, BIG_FRAME_W);
    framesList.push(image);
  }

  return framesList;
};
